/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EscalationTierRequest } from './EscalationTierRequest';
import {
    EscalationTierRequestFromJSON,
    EscalationTierRequestFromJSONTyped,
    EscalationTierRequestToJSON,
    EscalationTierRequestToJSONTyped,
} from './EscalationTierRequest';

/**
 * Request to start escalation workflow
 * @export
 * @interface EscalationRequest
 */
export interface EscalationRequest {
    /**
     * Escalation tiers (notify tier 1, await ACK or timeout, then tier 2, etc.)
     * @type {Array<EscalationTierRequest>}
     * @memberof EscalationRequest
     */
    tiers: Array<EscalationTierRequest>;
    /**
     * Timeout in minutes per tier before escalating
     * @type {number}
     * @memberof EscalationRequest
     */
    timeoutMinutes: number;
    /**
     * Tenant ID (optional; uses session tenant if not provided)
     * @type {string}
     * @memberof EscalationRequest
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the EscalationRequest interface.
 */
export function instanceOfEscalationRequest(value: object): value is EscalationRequest {
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    if (!('timeoutMinutes' in value) || value['timeoutMinutes'] === undefined) return false;
    return true;
}

export function EscalationRequestFromJSON(json: any): EscalationRequest {
    return EscalationRequestFromJSONTyped(json, false);
}

export function EscalationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscalationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tiers': ((json['tiers'] as Array<any>).map(EscalationTierRequestFromJSON)),
        'timeoutMinutes': json['timeoutMinutes'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function EscalationRequestToJSON(json: any): EscalationRequest {
    return EscalationRequestToJSONTyped(json, false);
}

export function EscalationRequestToJSONTyped(value?: EscalationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tiers': ((value['tiers'] as Array<any>).map(EscalationTierRequestToJSON)),
        'timeoutMinutes': value['timeoutMinutes'],
        'tenantId': value['tenantId'],
    };
}

